exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".token-cell {\n  display: inline-block;\n  max-width: 180px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.text-danger {\n  color: #e73d4a;\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/manage/providers/providers.component.css
// module id = 592
// module chunks = 0